export const NAME_TITLES = ['Ms.', 'Mrs.', 'Mr.'] as const;

export type NameTitle = (typeof NAME_TITLES)[number];

export function parseNameAndTitle(fullName: string): { title: string; name: string } {
  const trimmed = (fullName ?? '').trim();
  if (!trimmed) {
    return { title: '', name: '' };
  }

  for (const title of NAME_TITLES) {
    const prefix = `${title} `;
    if (trimmed.startsWith(prefix)) {
      return { title, name: trimmed.slice(prefix.length).trim() };
    }
  }

  return { title: '', name: trimmed };
}

export function formatNameWithTitle(title: string, name: string): string {
  const bareName = parseNameAndTitle((name ?? '').trim()).name;
  const trimmedTitle = (title ?? '').trim();
  if (!trimmedTitle) {
    return bareName;
  }
  return bareName ? `${trimmedTitle} ${bareName}` : trimmedTitle;
}

export function normalizeUserNameTitle(user: {
  strName?: string;
  strTitle?: string;
}): { strName: string; strTitle: string } {
  const storedTitle = (user.strTitle ?? '').trim();
  const parsed = parseNameAndTitle(user.strName ?? '');

  if (storedTitle) {
    const bareName =
      parsed.title === storedTitle ? parsed.name : parseNameAndTitle(user.strName ?? '').name;
    return { strName: bareName, strTitle: storedTitle };
  }

  if (parsed.title) {
    return { strName: parsed.name, strTitle: parsed.title };
  }

  return { strName: (user.strName ?? '').trim(), strTitle: '' };
}
